import { render, staticRenderFns } from "./NewsletterDialog.vue?vue&type=template&id=315d7594&"
import script from "./NewsletterDialog.vue?vue&type=script&lang=js&"
export * from "./NewsletterDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterDialog.vue?vue&type=style&index=0&id=315d7594&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports